__turbopack_context__.v({
  "background": "BrandSplitShell-module__tMgXXa__background",
  "formContainer": "BrandSplitShell-module__tMgXXa__formContainer",
  "formWrapper": "BrandSplitShell-module__tMgXXa__formWrapper",
  "logo": "BrandSplitShell-module__tMgXXa__logo",
  "shell": "BrandSplitShell-module__tMgXXa__shell",
});
